export default __webpack_public_path__ + "static/media/play.8ca0e8a3.png";